import * as React from 'react';
export const IcLoactionShare = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.66 4.34A8 8 0 004 10c0 5 5.94 10.8 6.62 11.45a2 2 0 002.76 0C14.06 20.8 20 15 20 10a8 8 0 00-2.34-5.66zM12 16a6 6 0 01-5.54-3.71 5.86 5.86 0 01-.34-3.46 6 6 0 011.64-3.07 6.08 6.08 0 013.07-1.65A6 6 0 1112 16zm0-4a1 1 0 00-.56.17.94.94 0 00-.36.45.93.93 0 00-.06.57 1 1 0 00.78.79c.195.038.397.017.58-.06a.91.91 0 00.45-.37 1 1 0 00-.12-1.26A.999.999 0 0012 12zm0-3a4 4 0 00-2.67 1 1 1 0 00-.26.31 1 1 0 00-.07.39 1.07 1.07 0 000 .4c.04.13.109.25.2.35.096.097.208.178.33.24.127.055.262.085.4.09a.881.881 0 00.39-.08 1 1 0 00.34-.22 2 2 0 012.66 0 1 1 0 00.67.26.902.902 0 00.4-.09 1 1 0 00.28-1.65A4 4 0 0012 9zm3.5-2.1a7.12 7.12 0 00-7 0 .93.93 0 00-.3.26.88.88 0 00-.2.35c-.02.13-.02.26 0 .39a1 1 0 00.39.66.88.88 0 00.35.17 1 1 0 00.39 0 1 1 0 00.37-.13 5.06 5.06 0 015 0 1 1 0 001.11-.07A.93.93 0 0016 8a1 1 0 000-.65 1.05 1.05 0 00-.5-.45z'
      fill='currentColor'
    />
  </svg>
);
